import axios from '@/libs/api.request'
var qs = require('qs')
    // 获取列表数据
export const fetchTableList = (params) => {

    let data = qs.stringify(params)
    return axios.request({
        url: '/system-account/list',
        data,
        method: 'post'
    })
};
//获取角色列表
export const fetchRoleList = (params) => {
    let data = qs.stringify(params)

    return axios.request({
        url: '/role-management/down',
        data,
        method: 'post'
    })
};
// 添加
export const seeAdd = (params) => {
    let data = qs.stringify(params)

    return axios.request({
        url: '/system-account/insert',
        data,
        method: 'post'
    })
};
// 修改
export const seeModify = (params) => {
    let data = qs.stringify(params)

    return axios.request({
        url: '/system-account/update',
        data,
        method: 'post'
    })
};
// 获取详情
export const fetchinfo = (params) => {
    let data = qs.stringify(params)

    return axios.request({
        url: '/system-account/info',
        data,
        method: 'post'
    })
};
// 改变状态
export const changeStatus = (params) => {
    let data = qs.stringify(params)

    return axios.request({
        url: '/system-account/change-status',
        data,
        method: 'post'
    })
}